<template>
  <div class="invoice-page">
    <div class="invoice-header" :style="'background:' + typeColor[payType] + ';'">
      <div class="invoice-header-amount">
        <div class="invoice-header-label">开票金额</div>
        <div class="invoice-header-money">￥{{ amount }}</div>
      </div>
    </div>

    <div class="invoice-section">
      <div class="invoice-section-title">抬头信息</div>
      <div class="invoice-section-body">
        <div class="invoice-field">
          <label class="invoice-label">类型</label>
          <div class="invoice-type-switch">
            <div
                class="invoice-type-item"
                :class="{ active: form.titleType === 'enterprise' }"
                :style="form.titleType === 'enterprise' ? 'background:' + typeColor[payType] + ';color:#fff;' : ''"
                @click="form.titleType = 'enterprise'"
            >企业</div>
            <div
                class="invoice-type-item"
                :class="{ active: form.titleType === 'personal' }"
                :style="form.titleType === 'personal' ? 'background:' + typeColor[payType] + ';color:#fff;' : ''"
                @click="form.titleType = 'personal'"
            >个人</div>
          </div>
        </div>
        <div class="invoice-field invoice-field-search">
          <label class="invoice-label">抬头名称</label>
          <div class="invoice-search-wrap">
            <input
                v-model="form.titleName"
                class="invoice-input"
                :placeholder="form.titleType === 'enterprise' ? '请输入企业名称' : '请输入个人姓名'"
                @input="onTitleNameInput"
                @focus="showDropdown = purchaserList.length > 0"
                @blur="onInputBlur"
                autocomplete="off"
            />
            <!-- <div v-if="searchLoading" class="invoice-search-loading">搜索中...</div> -->
            <div v-if="showDropdown && purchaserList.length > 0" class="invoice-search-dropdown">
              <div
                  v-for="(item, index) in purchaserList"
                  :key="index"
                  class="invoice-search-item"
                  @mousedown.prevent="selectPurchaser(item)"
              >
                <div class="invoice-search-item-name">{{ item.name }}</div>
                <div class="invoice-search-item-taxno">{{ item.taxNo }}</div>
              </div>
            </div>
          </div>
          <!-- <div
              v-if="isWechat"
              class="invoice-choose-btn"
              :style="'color:' + typeColor[payType] + ';border-color:' + typeColor[payType] + ';'"
              @click="chooseInvoiceTitle"
          >选择</div> -->
        </div>
        <div class="invoice-field" v-if="form.titleType === 'enterprise'">
          <label class="invoice-label">企业税号</label>
          <input v-model="form.taxNo" class="invoice-input" placeholder="请输入企业税号" />
        </div>
      </div>
    </div>

    <div class="invoice-section">
      <div class="invoice-section-title">支付开票信息</div>
      <div class="invoice-section-body">
        <div class="invoice-field">
          <label class="invoice-label">商品名称</label>
          <input v-model="form.goodsName" class="invoice-input" placeholder="请输入商品名称" />
        </div>
        <div class="invoice-field">
          <label class="invoice-label">商品金额</label>
          <div class="invoice-value">￥{{ amount }}</div>
        </div>
        <div class="invoice-field">
          <label class="invoice-label">开票备注</label>
          <input v-model="form.invoiceRemark" class="invoice-input" placeholder="选填" />
        </div>
      </div>
    </div>

    <div class="invoice-section">
      <div class="invoice-section-title">联系方式</div>
      <div class="invoice-section-body">
        <div class="invoice-field">
          <label class="invoice-label">手机号</label>
          <input v-model="form.phone" class="invoice-input" type="tel" placeholder="请输入手机号" />
        </div>
        <div class="invoice-field">
          <label class="invoice-label">邮箱</label>
          <input v-model="form.email" class="invoice-input" type="email" placeholder="请输入邮箱（用于接收电子发票）" />
        </div>
      </div>
    </div>

    <div class="invoice-footer">
      <div
          class="invoice-submit-btn"
          :style="'background:' + typeColor[payType] + ';'"
          @click="submitAndPay"
      >
        确认付款+开票
      </div>
    </div>
  </div>
</template>

<script>
import { getPayPackage, getPayOrderInfo, submitInvoice, searchPurchaserInfo } from '@/api/api'
import config from "@/config";

/** 微信点金计划：须使用当前站点完整 URL + location.replace，不能用 router.push */
function buildWxpayPaySuccessUrl(query) {
  const origin = window.location.origin;
  const path = '/cashier/wxpay-pay-success';
  const params = new URLSearchParams();
  Object.keys(query).forEach((k) => {
    if (query[k] != null && query[k] !== '') params.set(k, String(query[k]));
  });
  const qs = params.toString();
  return qs ? `${origin}${path}?${qs}` : `${origin}${path}`;
}
export default {
  data() {
    return {
      amount: '',
      payType: 'wxpay',
      remark: '',
      payOrderInfo: {},
      resData: {},
      form: {
        titleType: 'enterprise',
        titleName: '',
        taxNo: '',
        goodsName: '',
        invoiceRemark: '',
        phone: '',
        email: ''
      },
      purchaserList: [],
      showDropdown: false,
      searchLoading: false,
      searchTimer: null,
      typeColor: {
        alipay: "#1678ff",
        wxpay: "#07c160",
        ysfpay: "#ff534d"
      },
      routeNameMap: {
        wxpay: 'CashierWxpay',
        alipay: 'CashierAlipay',
        ysfpay: 'CashierYsfpay'
      }
    }
  },
  computed: {
    isWechat() {
      return /MicroMessenger/i.test(navigator.userAgent)
    }
  },
  mounted() {
    this.amount = this.$route.query.amount || '';
    this.payType = this.$route.query.payType || 'wxpay';
    this.remark = this.$route.query.remark || '';
    this.setPayOrderInfo();
  },
  methods: {
    onTitleNameInput() {
      if (this.form.titleType !== 'enterprise') {
        this.purchaserList = []
        this.showDropdown = false
        return
      }
      clearTimeout(this.searchTimer)
      const term = this.form.titleName
      if (!term || term.length < 2) {
        this.purchaserList = []
        this.showDropdown = false
        return
      }
      this.searchTimer = setTimeout(() => {
        this.searchPurchaser(term)
      }, 300)
    },
    searchPurchaser(term) {
      this.searchLoading = true
      searchPurchaserInfo(term).then(list => {
        this.purchaserList = list || []
        this.showDropdown = this.purchaserList.length > 0
      }).catch(() => {
        this.purchaserList = []
        this.showDropdown = false
      }).finally(() => {
        this.searchLoading = false
      })
    },
    selectPurchaser(item) {
      this.form.titleName = item.name || ''
      this.form.taxNo = item.taxNo || ''
      this.purchaserList = []
      this.showDropdown = false
    },
    onInputBlur() {
      setTimeout(() => {
        this.showDropdown = false
      }, 200)
    },
    chooseInvoiceTitle() {
      const that = this
      const invoke = () => {
        // eslint-disable-next-line no-undef
        WeixinJSBridge.invoke('chooseInvoiceTitle', { scene: 1 }, function (res) {
          if (res.err_msg === 'chooseInvoiceTitle:ok') {
            const info = JSON.parse(res.choose_invoice_title_info || '{}')
            // type: "0" = 单位, "1" = 个人
            that.form.titleType = info.type === '0' ? 'enterprise' : 'personal'
            that.form.titleName = info.title || ''
            that.form.taxNo = info.taxNumber || ''
          }
        })
      }
      if (typeof WeixinJSBridge === 'undefined') {
        document.addEventListener('WeixinJSBridgeReady', invoke, false)
      } else {
        invoke()
      }
    },
    setPayOrderInfo() {
      const that = this;
      getPayOrderInfo().then(res => {
        that.payOrderInfo = res;
      }).catch(res => {
        that.$router.push({ name: config.errorPageRouteName, params: { errInfo: res.msg } });
      });
    },
    submitAndPay() {
      if (!this.form.titleName) {
        return alert('请输入抬头名称');
      }
      if (this.form.titleType === 'enterprise' && !this.form.taxNo) {
        return alert('请输入企业税号');
      }
      if (!this.form.phone) {
        return alert('请输入手机号');
      }
      this.pay();
    },
    pay() {
      const that = this;
      getPayPackage(this.amount, this.remark, null).then(res => {
        if (res.code && res.code != '0') {
          return alert(res.msg);
        }
        if (res.orderState != 1) {
          return alert(res.errMsg);
        }
        that.resData = res;
        if (that.payType === 'wxpay') {
          that.doWxpay();
        } else {
          that.doAlipay(res.alipayTradeNo);
        }
      }).catch(res => {
        that.$router.push({ name: config.errorPageRouteName, params: { errInfo: res.msg } });
      });
    },
    doWxpay() {
      const that = this;
      if (typeof WeixinJSBridge == "undefined") {
        if (document.addEventListener) {
          document.addEventListener('WeixinJSBridgeReady', that.onBridgeReady, false);
        } else if (document.attachEvent) {
          document.attachEvent('WeixinJSBridgeReady', that.onBridgeReady);
          document.attachEvent('onWeixinJSBridgeReady', that.onBridgeReady);
        }
      } else {
        that.onBridgeReady();
      }
    },
    onBridgeReady() {
      const that = this;
      // eslint-disable-next-line no-undef
      WeixinJSBridge.invoke(
          'getBrandWCPayRequest', JSON.parse(that.resData.payInfo),
          function(res) {
            if (res.err_msg == "get_brand_wcpay_request:ok") {
              that.onPaySuccess();
            } else if (res.err_msg == "get_brand_wcpay_request:cancel") {
              alert("支付取消");
            } else if (res.err_msg == "get_brand_wcpay_request:fail") {
              alert('支付失败:' + JSON.stringify(res));
            }
          }
      );
    },
    doAlipay(alipayTradeNo) {
      const that = this;
      if (!window.AlipayJSBridge) {
        document.addEventListener('AlipayJSBridgeReady', function () {
          that.callAlipay(alipayTradeNo);
        }, false);
      } else {
        that.callAlipay(alipayTradeNo);
      }
    },
    callAlipay(alipayTradeNo) {
      const that = this;
      // eslint-disable-next-line no-undef
      AlipayJSBridge.call("tradePay", {
        tradeNO: alipayTradeNo
      }, function (data) {
        if ("9000" == data.resultCode) {
          that.onPaySuccess();
        } else if ("8000" == data.resultCode || "6004" == data.resultCode) {
          alert(JSON.stringify(data));
        } else {
          alert('用户已取消！');
        }
      });
    },
    formatTime() {
      const now = new Date();
      return now.getFullYear() + '-' +
          String(now.getMonth() + 1).padStart(2, '0') + '-' +
          String(now.getDate()).padStart(2, '0') + ' ' +
          String(now.getHours()).padStart(2, '0') + ':' +
          String(now.getMinutes()).padStart(2, '0');
    },
    pushInvoiceRecord(timeStr) {
      const invRecord = {
        titleName: this.form.titleName,
        amount: this.amount,
        statusText: '开票中',
        createTime: timeStr,
        goodsName: this.form.goodsName || '商品'
      };
      let invRecords = JSON.parse(sessionStorage.getItem('invoiceRecords') || '[]');
      invRecords.push(invRecord);
      sessionStorage.setItem('invoiceRecords', JSON.stringify(invRecords));
    },
    redirectWxpayGoldPlan(invoiceOk) {
      const payOrderId = this.resData.payOrderId || this.payOrderInfo.payOrderId || '';
      const url = buildWxpayPaySuccessUrl({
        techpayxToken: config.cacheToken || '',
        payOrderId,
        amount: String(this.amount || ''),
        fromInvoice: '1',
        invoiceOk: invoiceOk ? '1' : '0'
      });
      window.location.replace(url);
    },
    onPaySuccess() {
      const that = this;
      const timeStr = that.formatTime();
      const payOrderId = that.resData.payOrderId || that.payOrderInfo.payOrderId || '';
      submitInvoice({
        invoiceTitleType: that.form.titleType === 'enterprise' ? 1 : 2,
        invoiceTitleName: that.form.titleName,
        invoiceTaxNo: that.form.taxNo,
        invoiceGoodsName: that.form.goodsName,
        amount: parseFloat(that.amount),
        invoiceRemark: that.form.invoiceRemark,
        invoicePhone: that.form.phone,
        invoiceEmail: that.form.email,
        payOrderId: payOrderId
      }).then(() => {
        that.pushInvoiceRecord(timeStr);
        if (that.payType === 'wxpay') {
          that.redirectWxpayGoldPlan(true);
          return;
        }
        alert('支付成功，发票开具中！');
        that.$router.push({ name: that.routeNameMap[that.payType], query: { fromInvoice: '1' } });
      }).catch(() => {
        if (that.payType === 'wxpay') {
          that.redirectWxpayGoldPlan(false);
          return;
        }
        alert('支付成功，但开票请求失败，请联系商家处理');
        that.$router.push({ name: that.routeNameMap[that.payType], query: { fromInvoice: '1' } });
      });
    }
  }
}
</script>

<style lang="css" scoped>
.invoice-page {
  min-height: 100vh;
  background: #f5f7fa;
  padding-bottom: 2.4rem;
}
.invoice-header {
  padding: 0.533333rem 0.4rem 0.8rem;
  border-radius: 0 0 0.4rem 0.4rem;
}
.invoice-header-label {
  font-size: 0.373333rem;
  color: rgba(255, 255, 255, 0.8);
}
.invoice-header-money {
  font-size: 0.8rem;
  font-weight: 600;
  color: #fff;
  margin-top: 0.133333rem;
}
.invoice-section {
  margin: 0.266667rem 0.4rem 0;
  background: #fff;
  border-radius: 0.266667rem;
}
.invoice-section-title {
  padding: 0.346667rem 0.4rem 0.133333rem;
  font-size: 0.4rem;
  font-weight: 600;
  color: #323232;
}
.invoice-section-body {
  padding: 0 0.4rem;
}
.invoice-field {
  display: flex;
  align-items: center;
  padding: 0.346667rem 0;
  border-bottom: 0.013333rem solid #f0f0f0;
}
.invoice-field:last-child {
  border-bottom: none;
}
.invoice-label {
  flex-shrink: 0;
  width: 2rem;
  font-size: 0.373333rem;
  color: #666;
}
.invoice-input {
  flex: 1;
  border: none;
  outline: none;
  font-size: 0.373333rem;
  color: #323232;
  text-align: right;
  background: transparent;
}
.invoice-input::placeholder {
  color: #c8c8c8;
}
.invoice-choose-btn {
  flex-shrink: 0;
  margin-left: 0.2rem;
  padding: 0.1rem 0.266667rem;
  font-size: 0.32rem;
  border: 0.013333rem solid;
  border-radius: 0.533333rem;
  white-space: nowrap;
}
.invoice-value {
  flex: 1;
  font-size: 0.373333rem;
  color: #323232;
  text-align: right;
}
.invoice-type-switch {
  flex: 1;
  display: flex;
  justify-content: flex-end;
  gap: 0.2rem;
}
.invoice-type-item {
  padding: 0.133333rem 0.4rem;
  border-radius: 0.533333rem;
  font-size: 0.346667rem;
  color: #666;
  background: #f5f7fa;
  cursor: pointer;
}
.invoice-field-search {
  position: relative;
}
.invoice-search-wrap {
  flex: 1;
  position: relative;
}
.invoice-search-wrap .invoice-input {
  width: 100%;
}
.invoice-search-loading {
  position: absolute;
  right: 0;
  top: 50%;
  transform: translateY(-50%);
  font-size: 0.32rem;
  color: #999;
}
.invoice-search-dropdown {
  position: absolute;
  top: 100%;
  left: 0;
  right: 0;
  background: #fff;
  border: 0.013333rem solid #e8e8e8;
  border-radius: 0.133333rem;
  box-shadow: 0 0.053333rem 0.266667rem rgba(0,0,0,0.12);
  z-index: 100;
  max-height: 6rem;
  overflow-y: auto;
}
.invoice-search-item {
  padding: 0.266667rem 0.32rem;
  border-bottom: 0.013333rem solid #f5f5f5;
  cursor: pointer;
}
.invoice-search-item:last-child {
  border-bottom: none;
}
.invoice-search-item:active {
  background: #f5f7fa;
}
.invoice-search-item-name {
  font-size: 0.373333rem;
  color: #323232;
}
.invoice-search-item-taxno {
  font-size: 0.32rem;
  color: #999;
  margin-top: 0.066667rem;
}
.invoice-footer {
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  padding: 0.266667rem 0.4rem;
  padding-bottom: calc(0.266667rem + env(safe-area-inset-bottom));
  background: #fff;
}
.invoice-submit-btn {
  height: 1.2rem;
  border-radius: 0.213333rem;
  color: #fff;
  font-size: 0.48rem;
  font-weight: 500;
  text-align: center;
  line-height: 1.2rem;
}
</style>
